import { baseSiteEndPoint, buildHeaders, getSellerID, urlFilters } from "./common";
import { authorizedFetch } from "./login";

export const apiCreateEventLogo = async (file) => {
  if (!file) {
    throw new Error("File is required");
  }

  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/upload_logo/`, {
      method: "POST",
      headers: {},
      body: formData,
    });

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiCreateEvent = async (payload) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiListEvents = async (filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiListAdminEvents = async (filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/event/admin/events/`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetEvent = async (id, sellerId = null) => {
  try {
    const sellerIdToUse = sellerId || getSellerID();
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${sellerIdToUse}/events/${id}/`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiEditEvent = async (id, payload) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${id}/`, {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiDeleteEvent = async (id) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${id}/`, {
      method: "DELETE",
      headers: buildHeaders(),
    });
    if (response.status === 204) {
      return { success: true };
    } else {
      const errorData = await response.json();
      throw new Error(errorData.message || "Erro ao deletar o evento");
    }
  } catch (error) {
    throw error;
  }
};

export const apiCreateEventTicket = async (id, payload) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${id}/tickets/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetEventTickets = async (id, ticketID, sellerId = null) => {
  try {
    const sellerIdToUse = sellerId || getSellerID();
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${sellerIdToUse}/events/${id}/tickets/`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetEventTicketDetail = async (id, ticketID) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${id}/tickets/${ticketID}/`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiEditEventTicket = async (id, ticketID, payload) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${id}/tickets/${ticketID}/`, {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiDeleteEventTicket = async (id, ticketID) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${id}/tickets/${ticketID}/`, {
      method: "DELETE",
      headers: buildHeaders(),
    });
    if (response.status === 204) {
      return { success: true };
    } else {
      const errorData = await response.json();
      throw new Error(errorData.message || "Erro ao deletar o ticket");
    }
  } catch (error) {
    throw error;
  }
};

export const apiGetEventNoAuth = async (id) => {
  try {
    const response = await fetch(`${baseSiteEndPoint}/event/event/${id}/`, {
      method: "GET",
      headers: buildHeaders(),
    });

    if (!response.ok) {
      throw new Error(`Erro na resposta: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiListEventsPay = async (eventID, filters, sellerId = null) => {
  try {
    const sellerIdToUse = sellerId || getSellerID();
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/event/seller/${sellerIdToUse}/events/${eventID}/checkouts/`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetEventCheckoutDetails = async (eventID, checkoutID, sellerId = null) => {
  try {
    const sellerIdToUse = sellerId || getSellerID();
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${sellerIdToUse}/events/${eventID}/checkouts/${checkoutID}/`, {
      method: "GET",
      headers: buildHeaders(),
    });
    let data = null;
    try {
      data = await response.json();
    } catch (parseError) {
      data = null;
    }
    if (!response.ok) {
      const error = new Error(data?.error || "Erro ao buscar a compra");
      error.status = response.status;
      throw error;
    }
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiMarkCheckoutAsPaid = async (eventID, checkoutID, sellerId, sendEmail = true) => {
  try {
    const sellerIdToUse = sellerId || getSellerID();
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${sellerIdToUse}/events/${eventID}/checkouts/${checkoutID}/mark-as-paid/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify({ send_email: sendEmail })
    });
    let data = null;
    try {
      data = await response.json();
    } catch (parseError) {
      data = null;
    }
    if (!response.ok) {
      const error = new Error(data?.error || "Erro ao marcar a compra como paga");
      error.status = response.status;
      throw error;
    }
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiResendCheckoutEmail = async (eventID, checkoutID, sellerId, email = null) => {
  try {
    const sellerIdToUse = sellerId || getSellerID();
    const payload = email ? { email } : {};
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${sellerIdToUse}/events/${eventID}/checkouts/${checkoutID}/resend-email/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(payload)
    });
    let data = null;
    try {
      data = await response.json();
    } catch (parseError) {
      data = null;
    }
    if (!response.ok) {
      const error = new Error(data?.error || "Erro ao reenviar os ingressos");
      error.status = response.status;
      throw error;
    }
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiAdminSearchCheckouts = async (filters) => {
  try {
    const query = new URLSearchParams(
      Object.entries(filters || {}).filter(([, v]) => v !== '' && v != null)
    ).toString();
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/admin/checkouts/${query ? `?${query}` : ''}`, {
      method: "GET",
      headers: buildHeaders(),
    });
    let data = null;
    try {
      data = await response.json();
    } catch (parseError) {
      data = null;
    }
    if (!response.ok) {
      const error = new Error(data?.error || "Erro ao buscar as compras");
      error.status = response.status;
      throw error;
    }
    return data;
  } catch (error) {
    throw error;
  }
};
